export default __webpack_public_path__ + "static/media/activity_banner_mobile.87e7b883.jpeg";